import { StoreOfferProduct } from '@common'

import { Container } from './Container'
import { Content } from './Content'
import { Heading } from './Heading'
import { Countdown, Footer, ValueBadge } from '../shared'

type Props = {
  product: StoreOfferProduct
}

export const SpecialOfferCard = ({ product }: Props) => {
  return (
    <Container product={product}>
      <Countdown product={product} />
      <ValueBadge product={product} />
      <Heading product={product} />
      <Content product={product} />
      <Footer product={product} />
    </Container>
  )
}
